import { Clickable, TeamBox, Text } from 'components';
import { theme } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Arrows } from '../../components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 39px;

  @media (max-width: 1024px) {
    margin-top: 60px;
    width: 100vw;
  }
`;

const SectionHeader = styled.div`
  width: 1140px;
  align-self: center;
  display: flex;
  justify-content: space-between;

  h2  {
    font-size: 72px;
  }

  @media (max-width: 1024px) {
    width: 100vw;

    h2 {
      font-size: 48px;
      margin: 0 13px;
    }
  }
`;

const BackgroundContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-end;
  margin-top: 3px;

  .scroll {
    ${navigator.platform !== 'Win32' ? 'overflow-x: scroll;' : 'overflow-x: hidden;'}

    @media (max-width: 1024px) {
      overflow-x: scroll;
    }
  }
`;

const RedArea = styled.div`
  height: 540px;
  width: 1280px;
  align-self: center;
  background-color: ${theme.SECONDARY};
  margin-top: -554px;
  z-index: -1;

  @media (max-width: 1024px) {
    height: 102px;
    margin-top: -90px;
  }
`;

const TeamsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  padding-left: ${(props) => props.extraPad};
  scroll-behavior: smooth;

  @media (min-width: 1024px) {
    margin-bottom: 25px;
  }

  @media (max-width: 1024px) {
    padding: 0 13px;
  }
`;

const GoToTeams = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 1140px;
  align-self: center;
  margin-top: 28px;

  p {
    font-size: 20px;
    letter-spacing: -0.35px;

    b {
      letter-spacing: -0.65px;
    }
  }
  @media (max-width: 1024px) {
    width: 100vw;
    margin-top: 23px;
    margin-right: 17px;

    p {
      font-size: 16px;
    }
  }
`;

const ArrowsContainer = styled.div`
  margin-top: 43px;
  margin-right: -1px;
`;

const Teams = ({ data }) => {
  const { t } = useTranslation();
  const [extraPad, setExtraPad] = useState('0px'),
    teamsRef = useRef(null),
    navigate = useNavigate();

  useEffect(() => {
    handleExtraPad();
  }, []);

  function handleExtraPad() {
    setExtraPad(`${(window.innerWidth - 1140) / 2}px`);
  }

  if (!data?.length) return null;

  return (
    <Container>
      <SectionHeader>
        <Text size="72px" bold stencil spacing="-3.5px">
          {t('website.ledByTeams')}
        </Text>

        <ArrowsContainer>
          <Arrows elem={teamsRef} />
        </ArrowsContainer>
      </SectionHeader>

      <BackgroundContainer>
        <div id="teamScroll" className="scroll" style={{ paddingLeft: extraPad }} ref={teamsRef}>
          <TeamsContainer>
            {data.map((x, i) => (
              <TeamBox marg="0 40px 0 0" key={i} item={x} />
            ))}
          </TeamsContainer>
        </div>

        <RedArea />
      </BackgroundContainer>

      <GoToTeams>
        <Clickable onClick={() => navigate('/partners-and-sponsors')}>
          <Text>
            {t('website.goto')}
            <b> {t('website.partnersAndSponsors')}</b>
          </Text>
        </Clickable>
      </GoToTeams>
    </Container>
  );
};

export default Teams;
